import axios from 'axios'
import appConfig from '@/appconfig'
import endpoint from '@constants/apipath'

export const actions = {
  sendOTP({ commit }, { emailId, notificationType } = {}) {
    var url = `${appConfig.apiEndPoint}${
      endpoint.identityApiPath.ipwhitelistotp
    }/${emailId}/${notificationType}`
    const headers = {
      'Content-Type': 'application/json',
    }
    return axios
      .post(url, {
        headers: headers,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },

  validateotp({ commit }, { emailId, otp, whitelistotp, countryId } = {}) {
    var otpData = JSON.stringify({
      EmailId: emailId,
      OTP: otp,
      WhitelistOTP: whitelistotp,
      CountryId: countryId,
    })
    var url = `${appConfig.apiEndPoint}${
      endpoint.identityApiPath.validateipwhitelistingotp
    }`
    const headers = {
      'Content-Type': 'application/json',
    }
    return axios
      .post(url, JSON.parse(otpData), {
        headers: headers,
      })
      .then((response) => {
        const user = response.data
        commit('auth/SET_CURRENT_USER', user, { root: true })
        commit('auth/loggedIn', true, { root: true })
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },
}
